import {createSlice} from '@reduxjs/toolkit';
import inactiveImg from '../assets/circle-solid-cultured-50.png';
import activeImg from '../assets/circle-solid-cultured-100.png';

const initialState = {
  // keyword: {
  //   inactive: inactiveFacebook,
  //   active: activeFacebook,
  //   graph: '/graph/facebook-square-brands-blue-yonder.png',
  //   name: 'related person'
  // }
};

const typesSlice = createSlice({
  name: 'types',
  initialState,
  reducers: {
    addType: (state, action) => {
      const keyword = action.payload;
      let newType = {};
      newType[keyword] = {
        inactive: inactiveImg,
        active: activeImg,
        graph: '/graph/circle-solid-gamboge.png',
        name: keyword.replace('_', ' ')
      };
      return Object.assign(newType, {...state});
    }
  }
});

const {addType} = typesSlice.actions;

const typesReducer = typesSlice.reducer;

const selectTypes = (state) => state.types;

export {
  addType,
  typesReducer,
  selectTypes
};